import {
  FiMail,
  FiMapPin,
  FiMessageSquare,
  FiPhoneCall,
  FiSend,
  FiUser,
} from "react-icons/fi";

const contactCards = [
  {
    icon: FiMail,
    label: "Email",
    value: "himanshu872668@gmail.com",
    href: "mailto:himanshu872668@gmail.com",
    detail: "Best for project inquiries and collaboration.",
  },
  {
    icon: FiPhoneCall,
    label: "Phone",
    value: "+91-8726688726",
    href: "tel:+918726688726",
    detail: "Available for quick calls and urgent follow-ups.",
  },
  {
    icon: FiMapPin,
    label: "Location",
    value: "India",
    href: "#contact",
    detail: "Open to remote opportunities worldwide.",
  },
];

export default function Contact() {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for your message! I'll get back to you soon.");
    e.target.reset();
  };

  return (
    <section
      id="contact"
      className="relative overflow-hidden bg-[#07090c] py-20 text-white sm:py-24"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,180,80,0.18),transparent_35%),radial-gradient(circle_at_bottom_right,rgba(0,200,200,0.12),transparent_38%)]" />
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(255,255,255,0.03),transparent_20%,transparent_80%,rgba(0,0,0,0.55))]" />
      <div className="absolute left-1/2 top-16 h-80 w-80 -translate-x-1/2 rounded-full bg-cyan-400/10 blur-3xl animate-float" />

      <div className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-12 max-w-3xl text-center sm:mb-16">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.4em] text-cyan-300/80">
            Contact
          </p>
          <h2 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
            <span className="text-gray-200">Get In</span>{" "}
            <span className="bg-linear-to-r from-orange-300 via-amber-300 to-cyan-300 bg-clip-text text-transparent">
              Touch
            </span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-gray-400 sm:text-base">
            Have an idea, a role, or a project? Send a message and I’ll reply
            with clear next steps.
          </p>
        </div>

        <div className="grid gap-8 lg:grid-cols-[1.15fr_0.85fr] lg:items-start">
          <div className="rounded-3xl border border-white/10 bg-white/5 p-5 shadow-[0_0_80px_rgba(0,0,0,0.35)] backdrop-blur-xl sm:p-8">
            <div className="mb-6 flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-cyan-400/10 text-cyan-300 ring-1 ring-cyan-400/20">
                <FiSend className="text-lg" />
              </div>
              <div>
                <p className="text-sm font-semibold text-white">
                  Send a message
                </p>
                <p className="text-xs text-gray-400">
                  I usually respond as soon as possible.
                </p>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="animate-fade">
              <div className="grid gap-5 sm:grid-cols-2">
                <div className="sm:col-span-1">
                  <label className="mb-2 block text-xs font-medium uppercase tracking-[0.2em] text-gray-400">
                    Full Name
                  </label>
                  <div className="relative">
                    <FiUser className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" />
                    <input
                      type="text"
                      required
                      placeholder="Your name"
                      className="w-full rounded-2xl border border-white/10 bg-white/5 py-3.5 pl-11 pr-4 text-sm text-white placeholder:text-gray-500 outline-none transition-all duration-300 focus:border-cyan-400/70 focus:bg-white/8 focus:shadow-[0_0_0_4px_rgba(0,200,200,0.12)]"
                    />
                  </div>
                </div>

                <div className="sm:col-span-1">
                  <label className="mb-2 block text-xs font-medium uppercase tracking-[0.2em] text-gray-400">
                    Email Address
                  </label>
                  <div className="relative">
                    <FiMail className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-gray-500" />
                    <input
                      type="email"
                      required
                      placeholder="your.email@example.com"
                      className="w-full rounded-2xl border border-white/10 bg-white/5 py-3.5 pl-11 pr-4 text-sm text-white placeholder:text-gray-500 outline-none transition-all duration-300 focus:border-cyan-400/70 focus:bg-white/8 focus:shadow-[0_0_0_4px_rgba(0,200,200,0.12)]"
                    />
                  </div>
                </div>

                <div className="sm:col-span-2">
                  <label className="mb-2 block text-xs font-medium uppercase tracking-[0.2em] text-gray-400">
                    Subject
                  </label>
                  <input
                    type="text"
                    required
                    placeholder="What's this about?"
                    className="w-full rounded-2xl border border-white/10 bg-white/5 px-4 py-3.5 text-sm text-white placeholder:text-gray-500 outline-none transition-all duration-300 focus:border-cyan-400/70 focus:bg-white/8 focus:shadow-[0_0_0_4px_rgba(0,200,200,0.12)]"
                  />
                </div>

                <div className="sm:col-span-2">
                  <label className="mb-2 block text-xs font-medium uppercase tracking-[0.2em] text-gray-400">
                    Message
                  </label>
                  <div className="relative">
                    <FiMessageSquare className="pointer-events-none absolute left-4 top-4 text-gray-500" />
                    <textarea
                      required
                      rows="6"
                      placeholder="Tell me about your project, timeline, or idea..."
                      className="w-full resize-none rounded-2xl border border-white/10 bg-white/5 py-3.5 pl-11 pr-4 text-sm text-white placeholder:text-gray-500 outline-none transition-all duration-300 focus:border-cyan-400/70 focus:bg-white/8 focus:shadow-[0_0_0_4px_rgba(0,200,200,0.12)]"
                    />
                  </div>
                </div>
              </div>

              <button
                type="submit"
                className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-linear-to-r from-orange-300 via-amber-300 to-cyan-300 px-6 py-3.5 text-sm font-bold text-black shadow-[0_18px_50px_rgba(0,200,200,0.25)] transition-transform duration-300 hover:scale-[1.01] hover:shadow-[0_22px_60px_rgba(0,200,200,0.35)]"
              >
                Send Message <FiSend />
              </button>
            </form>
          </div>

          <div className="space-y-5">
            <div className="rounded-3xl border border-white/10 bg-white/5 p-5 backdrop-blur-xl sm:p-6">
              <p className="text-xs font-semibold uppercase tracking-[0.35em] text-cyan-300/80">
                Quick Info
              </p>
              <p className="mt-3 text-sm leading-7 text-gray-400">
                Clean communication, fast follow-up, and a straightforward
                process from first message to delivery.
              </p>
            </div>

            <div className="grid gap-5">
              {contactCards.map(
                ({ icon: Icon, label, value, href, detail }) => (
                  <a
                    key={label}
                    href={href}
                    className="group rounded-3xl border border-white/10 bg-white/5 p-5 backdrop-blur-xl transition-all duration-300 hover:-translate-y-1 hover:border-cyan-400/50 hover:bg-white/8 hover:shadow-[0_0_40px_rgba(0,200,200,0.18)]"
                  >
                    <div className="flex items-start gap-4">
                      <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-cyan-400/10 text-cyan-300 ring-1 ring-cyan-400/15 transition-colors duration-300 group-hover:bg-cyan-400/15">
                        <Icon className="text-xl" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gray-400">
                          {label}
                        </p>
                        <p className="mt-2 wrap-break-word text-lg font-semibold text-white sm:text-xl">
                          {value}
                        </p>
                        <p className="mt-2 text-sm leading-6 text-gray-400">
                          {detail}
                        </p>
                      </div>
                    </div>
                  </a>
                ),
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 h-32 w-full bg-linear-to-t from-black via-black/70 to-transparent" />
    </section>
  );
}
